'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _CartStore = require('../../stores/CartStore.jsx');

var _CartStore2 = _interopRequireDefault(_CartStore);

var _ScheduleScreenStore = require('../../stores/ScheduleScreenStore.jsx');

var _ScheduleScreenStore2 = _interopRequireDefault(_ScheduleScreenStore);

var _reflux = require('reflux');

var _reflux2 = _interopRequireDefault(_reflux);

var _Utility = require('../../utils/Utility.jsx');

var Utils = _interopRequireWildcard(_Utility);

var _Actions = require('../../Actions.jsx');

var _Actions2 = _interopRequireDefault(_Actions);

var _Address = require('../account/Address.jsx');

var _Address2 = _interopRequireDefault(_Address);

var _AddressList = require('./address/AddressList.jsx');

var _AddressList2 = _interopRequireDefault(_AddressList);

var _parse = require('parse');

var _parse2 = _interopRequireDefault(_parse);

var _Spinner = require('../generic/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _MainStore = require('../../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _sweetalert = require('sweetalert2');

var _sweetalert2 = _interopRequireDefault(_sweetalert);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NO_ADDRESS_MSG = "You have not saved any delivery address.";
var DELIVERY_NOT_AVAILABLE_MSG = "Pick Up only. Delivery is not available.";
// OutSide Delivery Range Message
var DELIVERY_OUTSIDE_RANGE_MESSAGE = "Delivery is not available for this address, It is outside our delivery zone.";
var DELIVERY_FEE_NOT_SELECTED = "Delivery fee may vary according to the address.";
var DELIVERY_FEE_SELECTED = "Based on the address, delivery fee is ";

var DeliveryAddressSelect = function (_React$Component) {
    _inherits(DeliveryAddressSelect, _React$Component);

    function DeliveryAddressSelect(props) {
        _classCallCheck(this, DeliveryAddressSelect);

        var _this = _possibleConstructorReturn(this, (DeliveryAddressSelect.__proto__ || Object.getPrototypeOf(DeliveryAddressSelect)).call(this, props));

        _this.onAddressSubmit = function (addressObject) {
            $(_this.refs.collapseTwo).collapse('toggle');
            var copyAddressContainer = _this.state.addressContainer.concat(addressObject);
            _this.setState({
                addressContainer: copyAddressContainer,
                selectedDeliveryAddressIdx: _ScheduleScreenStore2.default.getCurrentAddressIndex()
            });
        };

        _this.calculateDistances = function (deliveryAddress) {

            // if the selected delivery address is empty then show the error
            if (Utils.isEmptyObj(deliveryAddress)) {
                _this.clearCartDeliveryCalculations();
                _this.setFailureState();
                return;
            }

            // get deliveryInfo object value
            var isDeliveryCoordinates = _CartStore2.default.getDeliveryCoordinates();
            var deliveryAddressStr = Utils.getDeliveryAddressSearchStr(deliveryAddress);
            if (isDeliveryCoordinates != null) {
                var geocoder = new google.maps.Geocoder();
                geocoder.geocode({
                    'address': deliveryAddressStr
                }, _this.callBackDeliveryCoordinates);
            } else {
                _this.getAddressDistance(deliveryAddressStr);
            }
        };

        _this.clearCartDeliveryCalculations = function () {
            _ScheduleScreenStore2.default.setDeliveryDistance(0);
            _ScheduleScreenStore2.default.setDeliveryDistanceInMeter(0);
            _ScheduleScreenStore2.default.setDeliveryFee(0);
            _ScheduleScreenStore2.default.setDeliveryFeeType('');
        };

        _this.setFailureState = function () {
            _this.setState({
                selectedDeliveryAddressIdx: '',
                isSelectedAddressValidated: false,
                isInvalidAddress: true,
                isAddressListCompEnabled: true,
                isLoading: false
            }, function () {
                // Actions.resetDeliveryAddress;
                // const selectedDeliveryAddressStr
                //     = this.state.addressContainer[this.state.selectedDeliveryAddressIdx];
                _this.props.handleDeliveryAddressSelect(null, null);
                Utils.hideSpinner();
            });
        };

        _this.setSuccessState = function () {

            _this.setState({
                isSelectedAddressValidated: true,
                isInvalidAddress: false,
                isAddressListCompEnabled: false,
                isLoading: false
            }, function () {
                Utils.hideSpinner();

                var selectedDeliveryAddressObj = _this.state.addressContainer[_this.state.selectedDeliveryAddressIdx];

                _this.props.handleDeliveryAddressSelect(selectedDeliveryAddressObj, _this.state.selectedDeliveryAddressIdx);
            });
        };

        _this.callBackDeliveryCoordinates = function (response, status) {
            if (status != google.maps.DistanceMatrixStatus.OK) {
                _this.clearCartDeliveryCalculations();
                _this.setFailureState();
                return;
            } else {
                // Address string
                var deliveryAddressString = response[0].formatted_address;

                // delivery address lat & long
                var deliveryAddressCoordinates = response[0].geometry.location;

                // Location details object
                var locationDetail = _CartStore2.default.getLocationDetail();

                var origin = void 0;
                if (locationDetail.location) {
                    origin = {
                        lat: locationDetail.location.latitude,
                        lng: locationDetail.location.longitude
                    };
                } else {
                    origin = Utils.getAddressSearchStrFromLocation(locationDetail);
                }

                // get delivery maps coordinates
                var deliveryMapCoordinates = _CartStore2.default.getDeliveryCoordinates();

                // check address inside the polygon map or not
                var checkInPolygon = _this.checkInPolygon(deliveryAddressCoordinates, deliveryMapCoordinates, origin);

                console.log(checkInPolygon);

                if (checkInPolygon != true) {
                    // alert(DELIVERY_OUTSIDE_RANGE_MESSAGE);

                    //hide schedule Modal befoe
                    //opening schedule modal
                    _this.props.callBackParent();

                    _sweetalert2.default.fire({
                        title: 'Outside of Delivery Range',
                        text: DELIVERY_OUTSIDE_RANGE_MESSAGE,
                        icon: 'warning',
                        showConfirmButton: false,
                        showCancelButton: true,
                        cancelButtonText: 'Close',
                        customClass: {
                            cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
                        },
                        allowOutsideClick: false
                    }).then(function (result) {
                        if (result.isDismissed) {
                            var scheduleOrderModal = document.getElementById("scheduleOrderModal");
                            if (scheduleOrderModal) {
                                scheduleOrderModal.style.display = "block";
                            }
                        }
                    });

                    _this.clearCartDeliveryCalculations();
                    _this.setFailureState();
                    return;
                } else {
                    // call the function and get address distance
                    _this.getAddressDistance(deliveryAddressString);
                }
            }
        };

        _this.checkInPolygon = function (addressCoordinates, letlongCoords, locationCenter) {
            var map = new google.maps.Map(document.getElementById("map_canvas"), {
                center: locationCenter
                // center: new google.maps.LatLng(37.4419, -122.1419),
            });

            var bermudaTriangle = new google.maps.Polygon({
                map: map,
                paths: letlongCoords
            });

            // address inside the polygon or not
            if (google.maps.geometry.poly.containsLocation(addressCoordinates, bermudaTriangle)) {
                return true;
            } else {
                return false;
            }
        };

        _this.callback = function (response, status) {
            if (status != google.maps.DistanceMatrixStatus.OK) {
                _this.clearCartDeliveryCalculations();
                _this.setFailureState();
                return;
            } else {

                var locationDetail = _CartStore2.default.getLocationDetail();

                var routes = response.rows[0];

                var lowestDistance = Number.POSITIVE_INFINITY;
                var resultText = "Possible Routes:";
                var tmp = void 0;
                var shortestRouteIdx = void 0;

                // get deliveryInfo object value
                var locationDeliveryInfo = _CartStore2.default.getDeliveryInfo();

                for (var i = routes.elements.length - 1; i >= 0; i--) {

                    if (routes.elements[i].distance) {
                        tmp = routes.elements[i].distance.value;
                        resultText += "Route " + ": " + routes.elements[i].distance.text + "";
                    }
                    if (tmp < lowestDistance) {
                        lowestDistance = tmp;
                        shortestRouteIdx = i;
                    }
                }

                if (lowestDistance == null || lowestDistance == Number.POSITIVE_INFINITY) {

                    //hide schedule Modal befoe
                    //opening schedule modal
                    _this.props.callBackParent();

                    // alert(`Selected address distance can not be calculated accurately. Either choose Pick Up option or call Restaurant at ${Utils.formatPhoneNumber(locationDetail.phoneNumber)} to check if they can deliver.`);
                    _sweetalert2.default.fire({
                        title: "Error",
                        text: 'Selected address distance can not be calculated accurately. Either choose Pick Up option or call Restaurant at ' + Utils.formatPhoneNumber(locationDetail.phoneNumber) + ' to check if they can deliver.',
                        icon: 'warning',
                        showConfirmButton: false,
                        showCancelButton: true,
                        cancelButtonText: 'Close',
                        customClass: {
                            cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
                        },
                        allowOutsideClick: false
                    }).then(function (result) {
                        if (result.isDismissed) {
                            var scheduleOrderModal = document.getElementById("scheduleOrderModal");
                            if (scheduleOrderModal) {
                                scheduleOrderModal.style.display = "block";
                            }
                        }
                    });

                    _this.clearCartDeliveryCalculations();
                    _this.setFailureState();
                    return;
                }

                // get the discounted total amount
                // let orderTotalAmount = CartStore.getCartSubTotalWithDiscountAbs();

                // distance in miles
                var distanceInMiles = Utils.getMeterInMiles(lowestDistance);
                // distance in meter
                var distanceInMeter = lowestDistance;

                // check if the deliveryInfo exist or not
                if (locationDeliveryInfo) {
                    // const minAmount = Utils.extractWebsiteConfig(locationDeliveryInfo, "minAmount");
                    var deliveryFeeType = Utils.extractWebsiteConfig(locationDeliveryInfo, "feeType");

                    // get the delivery distance in meters
                    var maxRange = _CartStore2.default.getMaxDeliveryDistanceInMeters();

                    if (lowestDistance > maxRange) {
                        // alert(DELIVERY_OUTSIDE_RANGE_MESSAGE);

                        //hide schedule Modal befoe
                        //opening schedule modal
                        _this.props.callBackParent();

                        _sweetalert2.default.fire({
                            title: "Outside of Delivery Range",
                            text: DELIVERY_OUTSIDE_RANGE_MESSAGE,
                            icon: 'warning',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'Close',
                            customClass: {
                                cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
                            },
                            allowOutsideClick: false
                        }).then(function (result) {
                            if (result.isDismissed) {
                                var scheduleOrderModal = document.getElementById("scheduleOrderModal");
                                if (scheduleOrderModal) {
                                    scheduleOrderModal.style.display = "block";
                                }
                            }
                        });

                        _this.clearCartDeliveryCalculations();
                        _this.setFailureState();
                        return;
                    }

                    _ScheduleScreenStore2.default.setDeliveryDistance(distanceInMiles);
                    _ScheduleScreenStore2.default.setDeliveryDistanceInMeter(distanceInMeter);
                    _ScheduleScreenStore2.default.setDeliveryFeeType(deliveryFeeType);
                    _this.setSuccessState();
                } else {
                    var deliveryFees = Utils.extractWebsiteConfig(locationDetail.deliveryConfig, "fee");
                    var _deliveryFeeType = Utils.extractWebsiteConfig(locationDetail.deliveryConfig, "feeType");
                    // const minAmount = Utils.extractWebsiteConfig(locationDetail.deliveryConfig, "minAmount");

                    var rangeMap = Utils.getDeliveryRange(deliveryFees);

                    var range = Object.keys(rangeMap);
                    var _maxRange = range[range.length - 1];
                    var maxRangeInMeters = Utils.convertMilesInMeters(_maxRange);

                    if (lowestDistance > maxRangeInMeters) {
                        //hide schedule Modal befoe
                        //opening schedule modal
                        _this.props.callBackParent();

                        _sweetalert2.default.fire({
                            title: "Outside of Delivery Range",
                            text: DELIVERY_OUTSIDE_RANGE_MESSAGE,
                            icon: 'warning',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: 'Close',
                            customClass: {
                                cancelButton: "swal2-confirm custom-btn-outline-primary swal2-cancel custom-primary" + " text-capitalize"
                            },
                            allowOutsideClick: false
                        }).then(function (result) {
                            if (result.isDismissed) {
                                var scheduleOrderModal = document.getElementById("scheduleOrderModal");
                                if (scheduleOrderModal) {
                                    scheduleOrderModal.style.display = "block";
                                }
                            }
                        });

                        _this.clearCartDeliveryCalculations();
                        _this.setFailureState();
                        return;
                    }

                    // call a function to calculate the delivery fee charges
                    // deliveryFee = CartStore.getDeliveryConfigFee(distanceInMiles, rangeMap, orderTotalAmount);

                    _ScheduleScreenStore2.default.setDeliveryDistance(distanceInMiles);
                    _ScheduleScreenStore2.default.setDeliveryDistanceInMeter(distanceInMeter);
                    // CartStore.setDeliveryFee(deliveryFee);
                    _ScheduleScreenStore2.default.setDeliveryFeeType(_deliveryFeeType);

                    _this.setSuccessState();
                }
            }
        };

        _this.onSelectionChanged = function (event) {
            var selectedDeliveryAddressIdx = event.currentTarget.value;
            // this.setState({ isLoading : true });

            Utils.showSpinner();
            var router = _this.props.history;
            var locId = null;

            // checked the user session is valid or not
            Utils.isUserSessionInvalid().then(function (response) {
                var selectedDeliveryAddressStr = _this.state.addressContainer[selectedDeliveryAddressIdx];

                _this.setState({
                    isSelectedAddressValidated: false,
                    selectedDeliveryAddressIdx: selectedDeliveryAddressIdx,
                    orderType: "Delivery"
                }, function () {
                    _this.calculateDistances(selectedDeliveryAddressStr);
                });
            }, function (error) {
                _this.clearCartDeliveryCalculations();
                _this.setFailureState();
                // check the error and alert the invalid session token
                Utils.checkErrorIsInvalidSessionToken(error, router, locId, false);
            });
        };

        _this.showAddressListComp = function () {
            _this.setState(function (prevState) {
                return { isAddressListCompEnabled: !prevState.isAddressListCompEnabled };
            });
        };

        _this.renderAddedAddress = function () {
            var addresses = _this.state.addressContainer;
            // let checkDeliveryConfig = CartStore.getDeliveryConfigInfo();

            // if (checkDeliveryConfig == null) {
            //     return (<div>
            //                 <h4 className={"ml-3 color-red f16-default"}>{DELIVERY_NOT_AVAILABLE_MSG}</h4>
            //       </div>);
            // }

            if (addresses.length === 0) {
                return _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'h4',
                        { className: "ml-3 color-red f16-default" },
                        NO_ADDRESS_MSG
                    )
                );
            }

            // let deliveryMsgComponent = (<div>
            //         <h4  className="color-red f16-default">{DELIVERY_FEE_NOT_SELECTED}</h4>
            //     <span className="col-12 cart_border d-inline-block"/>
            //
            // </div>);


            return _react2.default.createElement(
                'div',
                { className: "cart-box px-4" },
                _react2.default.createElement(
                    'h4',
                    { className: "cart-heading f16-default mobile-ft-14" },
                    'Deliver To:'
                ),
                _react2.default.createElement(_AddressList2.default, {
                    addresses: addresses,
                    selectedDeliveryAddressIdx: _this.state.selectedDeliveryAddressIdx,
                    onDeliverySelectionChanged: _this.onSelectionChanged
                })
            );
        };

        _this.renderSelectedAddressLabel = function () {
            var address = _this.state.addressContainer[_this.state.selectedDeliveryAddressIdx];

            if (address && _this.state.isSelectedAddressValidated) {
                return _react2.default.createElement(
                    'div',
                    null,
                    _this.state.isAddressListCompEnabled == false ? _react2.default.createElement(
                        'div',
                        { className: "px-3" },
                        _react2.default.createElement(
                            'label',
                            { className: 'address-width-ctrl selected-address-label mt-1 pl-1' },
                            _react2.default.createElement(
                                'b',
                                { className: 'list-group-item-heading cart-header' },
                                (address.name || address.firstName) + ': '
                            ),
                            address.addLine1,
                            ' ',
                            address.addLine2,
                            ', ',
                            address.city,
                            ', ',
                            address.zipCode,
                            _react2.default.createElement(
                                'a',
                                {
                                    className: 'color-styl address-change-label',
                                    onClick: _this.showAddressListComp },
                                " ",
                                _react2.default.createElement('i', {
                                    className: 'fa fa-chevron-right',
                                    'aria-hidden': 'true'
                                }),
                                ' ',
                                _react2.default.createElement(
                                    'span',
                                    null,
                                    'Change'
                                )
                            )
                        )
                    ) : null
                );
            }
            return null;
        };

        _this.getAddressListComponent = function () {

            var comp = null;

            if (!_this.state.isLoading) {
                comp = _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: 'list-group' },
                        _react2.default.createElement(_Spinner2.default, null),
                        _this.renderAddedAddress()
                    )
                );
            } else {
                comp = _react2.default.createElement(
                    'div',
                    { className: 'list-group text-center' },
                    _react2.default.createElement('i', { className: 'fa fa-spinner fa-pulse' })
                );
            }

            return comp;
        };

        _this.state = {
            addressContainer: [],
            deliveryDistances: [],
            shortestRouteIdx: 0,
            orderType: "",
            selectedDeliveryAddressIdx: '',
            isAddressListCompEnabled: true,
            isSelectedAddressValidated: false,
            isInvalidAddress: true,
            isLoading: false
        };
        return _this;
    }

    _createClass(DeliveryAddressSelect, [{
        key: 'UNSAFE_componentWillMount',
        value: function UNSAFE_componentWillMount() {
            var _this2 = this;

            var isSavedAddressActive = _ScheduleScreenStore2.default.getSavedAddressActive();
            var setDefaultDeliveryAddressIdx = _ScheduleScreenStore2.default.getCurrentAddressIndex();

            if (!isSavedAddressActive) {
                setDefaultDeliveryAddressIdx = "";
            }

            var currentUser = _parse2.default.User.current();
            var isSelectedAddressValidated = false;
            var isAddressListCompEnabled = true;

            if (!currentUser) {
                return;
            }

            var deliveryAddress = currentUser.get("deliveryAddress") || [];
            var address = deliveryAddress[setDefaultDeliveryAddressIdx];

            if (address) {
                isSelectedAddressValidated = true;
                isAddressListCompEnabled = false;
            }

            if (deliveryAddress && deliveryAddress.length > 0) {
                // this.calculateDistances(deliveryAddress);
                this.setState({
                    orderType: "Delivery",
                    addressContainer: deliveryAddress,
                    selectedDeliveryAddressIdx: setDefaultDeliveryAddressIdx,
                    isSelectedAddressValidated: isSelectedAddressValidated,
                    isAddressListCompEnabled: isAddressListCompEnabled
                }, function () {
                    // set the default value
                    var selectedDeliveryAddressObj = _this2.state.addressContainer[_this2.state.selectedDeliveryAddressIdx];

                    _this2.props.handleDeliveryAddressSelect(selectedDeliveryAddressObj, _this2.state.selectedDeliveryAddressIdx);
                });
            } else {
                // set default order type with empty data
                this.setState({
                    orderType: "Delivery",
                    addressContainer: [],
                    selectedDeliveryAddressIdx: '',
                    isSelectedAddressValidated: isSelectedAddressValidated,
                    isAddressListCompEnabled: isAddressListCompEnabled
                }, function () {

                    // reset the delivery calculation and configuration
                    _this2.clearCartDeliveryCalculations();
                    _this2.setFailureState();
                });
            }
        }
    }, {
        key: 'getAddressDistance',


        // call the function and get address distance from location
        value: function getAddressDistance(deliveryAddress) {
            var locationDetail = _CartStore2.default.getLocationDetail();
            var origin = void 0;
            if (locationDetail.location) {
                origin = {
                    lat: locationDetail.location.latitude,
                    lng: locationDetail.location.longitude
                };
            } else {
                origin = Utils.getAddressSearchStrFromLocation(locationDetail);
            }
            // call the google API and get distance
            var service = new google.maps.DistanceMatrixService();
            service.getDistanceMatrix({
                origins: [origin], //array of origins
                destinations: [deliveryAddress], //array of destinations
                travelMode: google.maps.TravelMode.DRIVING,
                unitSystem: google.maps.UnitSystem.METRIC,
                avoidHighways: false,
                avoidTolls: false
            }, this.callback);
        }

        // Check the address coordinates in the polygon maps

        // renderSelectedAddressFee(){
        //
        //     const address = this.state.addressContainer[this.state.selectedDeliveryAddressIdx];
        //
        //     if (address && this.state.isSelectedAddressValidated) {
        //
        //         let deliveryFee = CartStore.getDeliveryFeeRounded(2);
        //
        //         return (<div>
        //             <h4  className="address-width-ctrl selected-address-label">{DELIVERY_FEE_SELECTED}<b  className="list-group-item-heading">${deliveryFee}</b></h4>
        //         </div>);
        //     }
        //
        //     return null;
        // };

        // renderAddAddressButton = () => {
        //     let checkDeliveryConfig = CartStore.getDeliveryConfigInfo();
        //
        //     if (checkDeliveryConfig != null) {
        //         return (
        //             <button
        //                 className="btn btn-default btn-add-address btn-button-link"
        //                 onClick={this.props.showAddressAddStructure}
        //             >
        //                 <i
        //                     className="fa fa-chevron-right"
        //                     aria-hidden="true"
        //                 ></i> ADD NEW ADDRESS
        //             </button>
        //         );
        //     }
        //     return null;
        // };


    }, {
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                'div',
                { className: "cart-box" },
                this.renderSelectedAddressLabel(),
                this.state.isAddressListCompEnabled ? this.getAddressListComponent() : null
            );
        }
    }]);

    return DeliveryAddressSelect;
}(_react2.default.Component);

exports.default = DeliveryAddressSelect;


//////////////////
// WEBPACK FOOTER
// ./src/components/schedule/DeliveryAddressSelect.jsx
// module id = 491
// module chunks = 0